import React from 'react';
import { notification } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';

type ToastType = 'success' | 'error' | 'warning' | 'info';

interface ToastOptions {
  duration?: number;
  onClose?: () => void;
}

const iconMap: Record<ToastType, IconProp> = {
  success: regular('circle-check'),
  error: regular('circle-exclamation'),
  warning: regular('triangle-exclamation'),
  info: regular('circle-info'),
};

notification.config({
  maxCount: 5,
});

const openToast = (type: ToastType, message: React.ReactNode, options?: ToastOptions) => {
  notification[type]({
    message,
    icon: <FontAwesomeIcon icon={iconMap[type]} fontSize={14} />,
    closeIcon: <FontAwesomeIcon icon={regular('close')} fontSize={14} />,
    className: `next-notification next-${type}-notification`,
    placement: 'top',
    duration: options?.duration ?? 4.5,
    onClose: options?.onClose,
  });
};

export const toast = {
  success: (message: React.ReactNode, options?: ToastOptions) =>
    openToast('success', message, options),
  error: (message: React.ReactNode, options?: ToastOptions) => openToast('error', message, options),
  warning: (message: React.ReactNode, options?: ToastOptions) =>
    openToast('warning', message, options),
  info: (message: React.ReactNode, options?: ToastOptions) => openToast('info', message, options),
};
